import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { getCurrentUser, patchCurrentBranch } from '../../api/usersAPI';

import './UserInfo.css';

export default function UserInfo() {
  const [user, setUser] = useState(null);
  const [currentBranch, setCurrentBranch] = useState('');

  const handleBranchChange = async (event) => {
    const branchId = event.target.value;

    try {
      await patchCurrentBranch({ current_branch: branchId });
      setCurrentBranch(branchId);
    } catch (error) {
      console.error('Error updating current branch:', error);
    }
  };

  useEffect(() => {
    async function fetchUser() {
      try {
        const response = await getCurrentUser();
        setUser(response.data);
        setCurrentBranch(response.data.current_branch ?? '');
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    }

    fetchUser();
  }, []);

  if (!user) {
    return <Typography></Typography>;
  }

  return (
    <Box className='user-info'>
      <Typography className='user-info__business'>{user.business_name}</Typography>
      <Link to='/settings' className='user-info__link'>
        <Typography className='user-info__name'>{user.full_name}</Typography>
      </Link>
      <Link to='/settings' className='user-info__link'>
        <Typography className='user-info__email'>{user.email}</Typography>
      </Link>
      <FormControl fullWidth size='small' sx={{ mt: 1 }}>
        <InputLabel id='branch-select-label' sx={{ fontSize: '0.75rem' }}>Current Branch</InputLabel>
        <Select
          labelId='branch-select-label'
          value={currentBranch}
          onChange={handleBranchChange}
          label='Current Branch'
          size='small'
          variant='outlined'
          sx={{ fontSize: '0.75rem' }}
        >
          {user.all_branches.map((branch) => (
            <MenuItem key={branch.id} value={branch.id}>
              {branch.name ? `${branch.name} - ${branch.address}` : branch.address}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Link to='/logout'><Typography className='user-info__logout'>Logout</Typography></Link>
    </Box>
  );
}
